module.exports = "https://cdn.realtymogul.com/static/media/img_panel_opportunity.30e17cee.jpg";